// extracted by mini-css-extract-plugin
export default {"success":"CandidateInterview_success__nSRh-"};